import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-differently-abled-facilities',
    templateUrl: './differently-abled-facilities.component.html',
    styleUrls: ['./differently-abled-facilities.component.scss']
})
export class DifferentlyAbledFacilitiesComponent implements OnInit {
    src: string = '/assets/pdf/Facilities for differently-abled.pdf';
    title: string = 'Facilities for differently-abled';

    constructor() { }

    ngOnInit(): void {
    }

}
